import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import RepositoryDetailDrawer from '../../../components/RepositoryDetailDrawer';
import { AwsRumContext } from '../../../components/RumContext';
import { VCS_SLUG } from '../../../constants/api';
import EmptyRepositoryPage from './EmptyRepositoryPage';
export const EmptyRepository = ({ user, repository, isUserLoggedIn }) => {
    const awsRum = useContext(AwsRumContext);
    awsRum?.recordError(`Error from user ${user?.username} (${user?.id}): Repository (${repository.id}: ${repository.fullname}) has no branches loaded.`);
    return _jsxs("div", { className: 'row', "data-testid": 'error-page', children: [_jsx(RepositoryDetailDrawer, { vcsSlug: VCS_SLUG[repository.vcs], fullName: repository.fullname, className: 'col col-12 col-md-2', isUserLoggedIn: isUserLoggedIn }), _jsx("div", { className: 'col col-12 col-md-10 repository-detail__content', children: _jsx(EmptyRepositoryPage, {}) })] });
};
